import FormModule from "components/Modules/Documents/FormModule"
import { campaignTypeOptions } from "constants/defaultValues/firebase"
import { firestoreObject } from "helpers/Firebase"
import {
  createOrUpdateFirestoreDocument,
  deleteFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import { callFirebaseFunction } from "helpers/Functions"
import HorizontalBannerListFields from "./CampaignTypesForms/HorizontalBannerListFields"
import SquareBannerFields from "./CampaignTypesForms/SquareBannerFields"

const fieldsToTranslate = [
  "Title",
  "SuperSuperTitle",
  "SuperTitle",
  "SubTitle",
  "SecondPage_Title",
  "SecondPage_Description",
]

const types = [
  {
    fields: SquareBannerFields,
    ID: "SquareBanner",
  },
  {
    fields: HorizontalBannerListFields,
    ID: "HorizontalBannerList",
  },
]

const CityCampaignForm = ({ opened }) => {
  const addOn = []

  types.forEach(type => {
    type.fields.forEach(field => {
      const Visible =
        typeof field.Visible === "function" ? field.Visible : vals => true

      addOn.push({
        ...field,
        Visible: vals => vals.Type === type.ID && Visible(vals),
      })
    })
  })

  return (
    <FormModule
      form={{
        title: "Campaign",
        fields: [
          {
            ID: "AC3EF22B-D27D-4B3B-B327-B196AE1C6317",
            Type: "Dropdown",
            Name: "Type",
            Label: "Type",
            GetSelectionOptions: async () => {
              return campaignTypeOptions
            },
          },
          {
            ID: "B1A4D3E3-4F0C-4D3A-9E3C-123456789012",
            Type: "Dropdown",
            Name: "Status",
            Label: "Status of the Campaign",
            GetSelectionOptions: async () => {
              return [
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ]
            },
          },
          {
            ID: "D4E5F6A7-B8C9-0D1E-2F3A-456789012345",
            Type: "DateTime",
            Name: "DateOfEntry",
            Label: "Date of Entry",
          },

          ...addOn,
        ],
        fieldsToTranslate,
        getDefaultValues: async () => {
          if (!opened)
            return {
              Type: "SquareBanner",
              DateOfEntry: new Date(),
              Status: "active",
            }

          const data = await getFirestoreDocument({
            path: `Offers/Campaigns/DataBase/${opened}`,
            timestampKeys: ["DateOfEntry"],
          })

          return {
            ...data,
          }
        },
        onSubmit: async (values, { firebaseUID }) => {
          const AIResponse = await callFirebaseFunction("analyzeCampaign", {
            values,
          })
          const AIData = AIResponse.data

          if (AIData?.success) {
            const AIAnalysis = AIData.analysis

            values.Tags = [
              ...(AIAnalysis?.thematicCategories || []),
              ...(AIAnalysis?.tags || []),
            ]

            values.UserTypes = AIAnalysis?.userTypes || [
              "Citizen",
              "Tourist",
              "Nomad",
              "Student",
              "Guest",
            ]
          }

          return await createOrUpdateFirestoreDocument({
            path: "Offers/Campaigns/DataBase",
            timestampKeys: ["DateOfEntry"],
            values: {
              ...values,
              CityID: firebaseUID,
              UpdatedAt: firestoreObject.Timestamp.now(),
              Status: "active",
            },
          })
        },
        onDelete: async ({ firebaseUID }) => {
          return await deleteFirestoreDocument({
            path: `Offers/Campaigns/DataBase/${opened}`,
          })
        },
      }}
      ID={opened}
    />
  )
}

export default CityCampaignForm
